import React from 'react';

interface CardProps {
  title: string;
  children: React.ReactNode;
  className?: string;
  controls?: React.ReactNode; // For things like dropdowns
}

export const Card: React.FC<CardProps> = ({ title, children, className, controls }) => (
  <div className={`bg-card-color-100 dark:bg-gray-800 p-6 rounded-xl border border-gray-200 dark:border-gray-700 flex flex-col ${className}`}>
    <div className="flex justify-between items-center mb-4">
      <h3 className="text-base font-bold text-title-page-color-100 dark:text-white">
        {title}
      </h3>
      {controls}
    </div>
    <div className="flex-grow">{children}</div>
  </div>
);